"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Dialog_1 = require("@material-ui/core/Dialog");
var DialogActions_1 = require("@material-ui/core/DialogActions");
var DialogContent_1 = require("@material-ui/core/DialogContent");
var DialogContentText_1 = require("@material-ui/core/DialogContentText");
var DialogTitle_1 = require("@material-ui/core/DialogTitle");
var DriverKeeperPopupWidget = /** @class */ (function (_super) {
    __extends(DriverKeeperPopupWidget, _super);
    function DriverKeeperPopupWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doConfirmation = function () {
            _this.props.confirm();
            _this.props.hide();
        };
        return _this;
    }
    DriverKeeperPopupWidget.prototype.render = function () {
        var canAddMoreDrivers = this.props.canAddDriver === undefined ? true : this.props.canAddDriver;
        return (React.createElement(Dialog_1.default, { open: this.props.show, onClose: this.props.hide, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            React.createElement(DialogTitle_1.default, { id: "alert-dialog-title" },
                React.createElement("img", { alt: "alert-icon", "aria-hidden": "true", src: "/img/alert-grey-blue.svg", className: 'float-left' }),
                React.createElement("h2", { className: 'padding-top-10-margin-left-50' }, this.props.title)),
            React.createElement(DialogContent_1.default, null,
                React.createElement(DialogContentText_1.default, { id: "alert-dialog-description" },
                    "We can't cover you if the ",
                    this.props.driverFunction,
                    " of this car (",
                    React.createElement("b", { className: "text-color-dark" }, this.props.vehicleRegistrationNumber),
                    ") is not added to the policy.",
                    React.createElement("br", null),
                    canAddMoreDrivers && this.props.additionalDriversCount < 7 &&
                        React.createElement("b", { className: "text-color-dark" },
                            "Do you want to add a driver who is the ",
                            this.props.driverFunction,
                            " to the policy?"))),
            React.createElement(DialogActions_1.default, { className: "justify-content-center" },
                React.createElement("div", { className: "display-block width-100" },
                    React.createElement("button", { type: "button", className: "btn btn-back", onClick: this.props.hide }, "Cancel"),
                    canAddMoreDrivers && this.props.additionalDriversCount < 7 &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "btn-spacer" }),
                            React.createElement("button", { type: "button", className: "btn btn-primary btn-next-arrow-separate", onClick: this.doConfirmation }, "Yes, let's do this"))))));
    };
    return DriverKeeperPopupWidget;
}(React.Component));
exports.default = DriverKeeperPopupWidget;
//# sourceMappingURL=DriverKeeperPopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/DriverKeeperPopupWidget.js
// module id = 354
// module chunks = 0